import { IS_HOSTNAME_MATCHING, METRICS_ENABLED } from 'utils/consts';
import { noop, noopPromise } from 'utils/noop';

import * as adobeTarget from './adobeTarget';
import * as clearbit from './clearbit';
import * as facebook from './facebook';
import * as googleTagManager from './googleTagManager';
import * as hotjar from './hotjar';
import * as linkedin from './linkedin';
import * as rudderStack from './rudderStack';
import { EventTraits, LocationDetails, LocationTraits, OrganisationsTraits, UserTraits } from './types';

declare global {
  interface Window
    extends
      adobeTarget.WindowProperties,
      clearbit.WindowProperties,
      facebook.WindowProperties,
      googleTagManager.WindowProperties,
      hotjar.WindowProperties,
      linkedin.WindowProperties {}
}

export const isEnabled = METRICS_ENABLED && IS_HOSTNAME_MATCHING;

export const initProviders = isEnabled
  ? () => {
      adobeTarget.initialize();
      clearbit.initialize();
      facebook.initialize();
      googleTagManager.initialize();
      hotjar.initialize();
      linkedin.initialize();
    }
  : noop;

export const loadProviders = isEnabled
  ? () => {
      adobeTarget.load();
      clearbit.load();
      facebook.load();
      googleTagManager.load();
      hotjar.load();
      linkedin.load();
      rudderStack.load();
    }
  : noop;

export const trackPage = isEnabled
  ? (locationTraits: LocationTraits, locationDetails: LocationDetails) => {
      adobeTarget.trackPage(locationDetails);
      clearbit.trackPage();
      facebook.trackPage();
      googleTagManager.trackPage(locationTraits, locationDetails);
      rudderStack.trackPage();
    }
  : noop;

export const trackEvent = isEnabled
  ? (eventTraits: EventTraits) => {
      googleTagManager.trackEvent(eventTraits);
      rudderStack.trackEvent(eventTraits);
    }
  : noop;

export const identifyUser = isEnabled
  ? async (userTraits: UserTraits) => {
      clearbit.identifyUser(userTraits);
      googleTagManager.identifyUser(userTraits);
      rudderStack.identifyUser(userTraits);
    }
  : noop;

export const resetUser = isEnabled
  ? () => {
      clearbit.resetUser();
      googleTagManager.resetUser();
      rudderStack.resetUser();
    }
  : noop;

export const assignUserToOrganisations = isEnabled
  ? (organisationsTraits: OrganisationsTraits) => {
      rudderStack.assignUserToOrganisation(organisationsTraits);
    }
  : noop;

export const getData = isEnabled ? adobeTarget.getData : noopPromise;

export * from './types';
